<script>
  import axios from "axios"
  import { querystring, push } from "svelte-spa-router"
  import { onMount, onDestroy, afterUpdate } from "svelte"
  import notify from "../../../../Script/notify"
  import Dropdown from "../Shared/fontDropdown.svelte"
  import Footer from "../../../../Shared/footer.svelte"
  import Loader from "../../../../Shared/Slots/loader.svelte"
  import Navbar from "../../../../Shared/Navbar/index.svelte"
  import TextEditor from "../Shared/textEditor/index.svelte"
  import Preview from "../Shared/preview.svelte"
  import DocumentDropdown from "../../../../Shared/dropDown2.svelte"
  import ApplicationState from "../../../../Stores/applicationStates"
  import { flatenObject } from "../../../../Script/flatenObject"
  import { queryStringToJSON } from "../../../../Script/queryString"
  import Palette from "../List/Modules/Palette/index.svelte"
  import HeaderDropdown from "./Components/headerDropdown.svelte"
  import DeleteConfirmation from "../Shared/deleteConfirmation.svelte"
  import SuggestionModal from "./Modules/SuggestionModal/index.svelte"
  import FontSizeDropdown from "../Shared/fontSizeDropdown.svelte"
  import BackModal from "../../Documents/Shared/backModal.svelte"
  import { compareObjects } from "../../../../Script/compareObjects"
  import { getDocumentsList } from "../../../Publish/BulkUpload/Script/bulkUpload"
  import Loading from "../../Documents/Edit/components/loading.svelte"
  import { validateFile } from "../../../Publish/BulkUpload/Script/bulkUpload"
  import { parseInvalidAttributes } from "../../../../Script/parseAttributes"
  import { deleteRequest, getRequest, patchRequest } from "../../../../Script/apiMethods"

  /**
   * @type {String} text displayed with the svg loader while loading
   */
  let loadingText = "Fetching&nbsp;<strong>Template Details</strong>&nbsp;"
  /**
   * @type {Boolean} for showing Loader while loading the editable content
   */
  let showLoading = true
  /**
   * @type {Boolean} for showing Modal for previewing the email template
   */
  let previewModal = false

  /**
   * @typedef {Object} invalidNotification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {invalidNotification}
   */
  let invalidNotification = {
    close() {},
  }

  /**
   * @type {Boolean} for showing the Delete Email Template Confirmation Modal
   */
  let showDeleteModal = false
  /**
   * @type {Boolean} for showing the suggestion Modal for the Invaild varaibles Modal
   */
  let showSuggestionModal = false

  /**
   * @type {Number} indicates the maximum characters for the template name
   */
  let maxCharacters = 25

  /**
   * @type {Number} - maximum character count for template name
   */
  let maxCharHeaderText = 70

  /**
   * @type {Number} indicates the maximum characters for the template subject
   */
  let maxCharactersSubject = 70

  /**
   * @typedef {Object} maxNotification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {maxNotification}
   */
  let maxNotification = {
    close() {},
  }

  /**
   * @type {Boolean}- to open modal when press back
   */
  let showBackmodal = false
  /**
   * @type {String} indicates the active tab for the customize area
   */
  let activeTab = "cardHeader"
  /**
   * @type {Boolean} whether to show the customize area or not
   */
  let showCustomize = false

  /**
   * @type {import("../../../../Script/types").parsedJson}
   */
  let parsedJson = {}
  /**
   * @type {Object} parsed nested object flattened to simple object
   */
  let flatObject = {}
  /**
   * @type {Array} list of curly braced attributes extracted from the text editor
   */
  let editorValues
  /**
   * @type {String} image url for the email header
   */
  // let headerURL = ""

  let editorObj
  let timer

  /**
   * @typedef {Object} oldEmailData
   * @type {oldEmailData} Make a deep copy of the template and assign it to `oldEmailData`
   */
  let oldEmailData = {}

  /**
   * @type {import("../../../../Script/types").EmailTemplate}
   */
  let emailTemplate = {}

  let isSave = false
  /**
   * @type {String} - dropdown selected document template name
   */
  let docTempName

  //updating query string value using spa-router
  let query = queryStringToJSON($querystring)
  /**
   * @typedef {Object} notificationName
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {notificationName}
   */
  let notificationName = {
    close() {},
  }
  /**
   * @typedef {Object} notificationSubject
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {notificationSubject}
   */
  let notificationSubject = {
    close() {},
  }
  /**
   * @typedef {Object} notificationContent
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {notificationContent}
   */
  let notificationContent = {
    close() {},
  }
  /**
   * @typedef {Object} notificationDocument
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {notificationDocument}
   */
  let notificationDocument = {
    close() {},
  }
  /**
   * @typedef {Object} notificationURL
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {notificationURL}
   */
  let notificationURL = {
    close() {},
  }
  /**
   * @typedef {Object} notificationText
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {notificationText}
   */
  let notificationText = {
    close() {},
  }
  /**
   * @typedef {Object} notificationURLInContent
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {notificationURLInContent}
   */
  let notificationURLInContent = {
    close() {},
  }
  /**
   * @typedef {Object} notificationInvalidURL
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {notificationInvalidURL}
   */
  let notificationInvalidURL = {
    close() {},
  }
  let notificationInvaliFile = {
    close() {},
  }
  /**
   * @type {number} pageNumber
   */
  let page = 1
  /**
   * @type {number} total document count
   */
  let count
  /**
   * @type {number} total pages
   */
  let maxPage
  /**
   * @type {number} starting count of the docList
   */
  let startCount = 1
  /**
   * @type {number} ending count of the docList
   */
  let endCount = 10
  /**
   * @type {boolean} whether to show loading screen or not for dropdown
   */
  let showLoadingForDropDown = false

  let disableBtn

  /**
   * @type {Array<Object>} list of document template objects
   */
  let documentTemplates = []
  let loadDropdown = false
  /**
   * @type {File} header image file
   */
  let imageFile

  let header_txt_custom = []
  let header_bg_custom = []
  let body_bg_custom = []
  let email_bg_custom = []

  let qrSource = ""

  /**
   * @description Fetches a document template by ID.
   * @returns {Promise<void>}
   */
  const getDocumentTemplate = async () => {
    try {
      // Fetching document template by ID
      const { template } = await getRequest(`/api/swagger/v2/templates/documents/${emailTemplate.document}`, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      return template
    } catch (error) {
      throw error
    }
  }

  /**
   * @description Pushes a new state to the browser history and handles the onpopstate event.
   * @returns {Promise<void>}
   */
  const historyPushState = () => {
    return new Promise(async (resolve, reject) => {
      try {
        // Push a new state to the history whenever a new page is loaded
        window.history.pushState(null, null, window.location.href)

        // Handle the onpopstate event when the user navigates back or forward in history
        window.onpopstate = function (event) {
          // Check if the email template has unsaved changes
          if (compareObjects(oldEmailData, JSON.parse(JSON.stringify(emailTemplate))) === false) {
            // Push another state to prevent navigating back
            window.history.pushState(null, null, window.location.href)
            showBackmodal = true // Show the back modal to confirm navigation
          } else {
            // Reset showBackmodal to false when changes are saved
            showBackmodal = false
          }
        }
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  /**
   * loading editing templte details by updating its data to stores
   */
  onMount(async () => {
    try {
      disableBtn = true

      if (query.scroll) {
        setTimeout(() => {
          window.scrollTo({
            top: document.body.scrollHeight,
            behavior: "smooth",
          })
        }, 1000)
      }

      const { template } = await getRequest(`/api/swagger/v2/templates/emails/${query.id}`, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      // Make a deep copy of the template and assign it to `oldEmailData`
      oldEmailData = JSON.parse(JSON.stringify(template))

      // Assign the fetched email template to `emailTemplate`
      emailTemplate = template

      const DEFAULT_URL = "https://view.demo.print2block.in/docs/8349c8d73fb16a960b02dec9047bcc2c517497243375dd3247c47399dda31592"

      qrSource = `https://utils.print2block.in/qr/create/?size=120&data=${DEFAULT_URL}`

      emailTemplate.content = replaceQRSource(qrSource, emailTemplate.content)

      // Assign the header URL of the email template to `headerURL`
      // headerURL = emailTemplate.headerURL

      try {
        loadDropdown = true

        // Retrieve the list of documents
        let documentList = await getDocumentsList(page)

        count = documentList.count

        maxPage = Math.ceil(count / 10)

        endCount = maxPage == 1 ? count : endCount

        // show document templates by filtering only when they have name
        documentTemplates = documentList.templates.filter((a) => a.name)

        if (emailTemplate.document) {
          let documentData = await getDocumentTemplate()
          docTempName = documentData.name

          // Parse the metadata fetched from the API
          parsedJson = JSON.parse(JSON.parse(JSON.stringify(documentData.metadata)))
          parsedJson.url = ""
          parsedJson.expireOn = new Date(new Date().setDate(new Date().getDate() + 1)).toDateString().slice(4)
          parsedJson.date = new Date().toDateString().slice(4)
          parsedJson.title = ""
          parsedJson.documentID = "67d4e8f0b3c74621fa9e5b7c"

          flatObject = flatenObject(parsedJson)
        } else {
          docTempName = "None"
        }
      } catch (error) {
        throw error
      } finally {
        loadDropdown = false
      }
      await historyPushState()
    } catch (error) {
      const info = "PAGE: Edit Email template\nEVENT: onMount"
      notify.danger(error, info)
      push("/templates/email")
    } finally {
      showLoading = false
      disableBtn = false
    }
  })

  $: checkEmptyHeaderText(emailTemplate.headerText)

  /**
   * @description Function to check the empty header text
   * @param {String} text indicates the title of the email header
   */
  const checkEmptyHeaderText = (text) => {
    notificationText.close()
    if (emailTemplate.headerType == "text") {
      if (!text) {
        const info = "PAGE: Edit Email template\nEVENT: While validating email header text as empty or not reactively"
        notificationText = notify.danger("Header Text should not be empty", info)
      }
    }
  }

  /**
   * @description function to permanantly delete template from database and stores
   */
  const deleteTemplate = async () => {
    try {
      showDeleteModal = false
      loadingText = `Deleting&nbsp;<strong>${emailTemplate.name}</strong>&nbsp;`
      showLoading = true

      await deleteRequest(`/api/swagger/v2/templates/emails/${query.id}`, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      notify.success(`Email Template <strong style="hyphens: auto;">${emailTemplate.name}</strong> successfully <strong>deleted</strong>`)
      push("/templates/email")
    } catch (error) {
      const info = "PAGE: Edit Email template\nEVENT: While deleting email template"
      notify.danger(error, info)
    } finally {
      showLoading = false
    }
  }

  /**
   * @description function to save edited template
   */
  const saveTemplate = async () => {
    try {
      let validateContent = await validateEmailDetails()

      if (validateContent) {
        getEditorValues()

        // showing suggestion modal only if there is an irrelevantEditor Values otherwise previewModal is visible
        if (editorValues.length) {
          isSave = true
          showSuggestionModal = true
        } else {
          let checkURL = checkURLInContent()
          if (checkURL) {
            await saveAfterValidate()
          }
        }
      }
    } catch (error) {
      console.error(error)
      const info = "PAGE: Edit Email template\nEVENT: While updating email template"
      notify.danger(error, info)
    }
  }

  const replaceQRSource = (source, content) => {
    try {
      const parser = new DOMParser()
      const doc = parser.parseFromString(content, "text/html")

      let imageElem = doc.querySelectorAll(".qr")

      for (let i = 0; i < imageElem.length; i++) {
        if (imageElem[i]) {
          let newImage = doc.createElement("img")
          newImage.setAttribute("src", source)
          newImage.className = "qr"
          newImage.setAttribute("alt", "document-QR")
          newImage.setAttribute("width", "120")

          imageElem[i].replaceWith(newImage)
        }
      }

      return doc.body.innerHTML
    } catch (error) {
      throw error
    }
  }

  const validateEmailDetails = async () => {
    const info = "PAGE: Edit email template\nEVENT: While validating email template details"

    emailTemplate.name = emailTemplate.name.trim()
    emailTemplate.subject = emailTemplate.subject.trim()
    emailTemplate.content = emailTemplate.content.trim()

    //to prevent user to save template with empty name value
    if (!emailTemplate.name.length) {
      notificationName.close()
      notificationName = notify.danger("Kindly enter a name for a template", info)
      return false
    }

    //to prevent user to save template with empty subject value
    if (!emailTemplate.subject.length) {
      notificationSubject.close()
      notificationSubject = notify.danger("Kindly enter a subject for email", info)
      return false
    }

    //to prevent user to save template with empty emailtemplate content
    if (!emailTemplate.content || emailTemplate.content == "<p><br/></p>") {
      notificationContent.close()
      notificationContent = notify.danger("Email Content shouldnt be empty", info)
      return false
    }

    //to prevent user to save template without selecting document template
    if (emailTemplate.document == undefined && !$ApplicationState.addEmailTemplate) {
      notificationDocument.close()
      notificationDocument = notify.danger("You didnt select any document template.Kindly select the document template", info)
      return false
    }

    //to prevent user to save template with empty emailtemplate headerText
    if (!emailTemplate.headerText.trim() && emailTemplate.headerType == "text") {
      notificationText.close()
      notificationText = notify.danger("HeaderText shouldnt be empty", info)
      return false
    }

    if (emailTemplate.headerType === "image" && (!emailTemplate.headerURL || !emailTemplate.headerURL.trim())) {
      notificationURL.close()
      notificationURL = notify.danger("HeaderURL shouldn't be empty", info)
      return false
    }

    // if (emailTemplate.headerURL && emailTemplate.headerType == "image") {
    //   try {
    //     let image = await checkImage()
    //     if (!image.naturalHeight) throw "Invalid URL Found. Kindly enter the different URL"
    //   } catch (error) {
    //     console.error(error)
    //     notificationInvalidURL.close()
    //     notificationInvalidURL = notify.danger("Invalid URL Found. Kindly enter the different URL")
    //     return false
    //   }
    // }

    return true
  }

  const saveAfterValidate = async () => {
    try {
      loadingText = `Saving&nbsp;<strong>${emailTemplate.name}</strong>&nbsp; Template`
      showLoading = true

      let payload = { ...emailTemplate, content: replaceQRSource("{{qr}}", emailTemplate.content) }

      await patchRequest(`/api/swagger/v2/templates/emails/${query.id}`, payload, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      notify.success(`Email template <strong style="hyphens: auto;">${emailTemplate.name}</strong> saved successfully`)
      push("/templates/email")
    } catch (error) {
      const info = "PAGE: Edit email template\nEVENT: While updating email template after validation"
      notify.danger(error, info)
    } finally {
      showLoading = false
    }
  }

  /**
   * @description Function for checking whether the conditions satisfied for previewing email template
   */
  const previewTemplate = async () => {
    let validateContent = await validateEmailDetails()

    if (validateContent) {
      getEditorValues()

      // showing suggestion modal only if there is an irrelevantEditor Values otherwise previewModal is visible
      if (editorValues.length) {
        showSuggestionModal = true
      } else {
        let checkURL = checkURLInContent()
        if (checkURL) {
          showCustomize = false
          previewModal = true
          scrollTotop()
        }
      }
    }
  }

  const checkURLInContent = () => {
    let tempEditorValues = Array.from(new Set(emailTemplate.content.match(/(?<=\{\{).*?(?=\}\})/g)))

    if (!tempEditorValues.includes("url")) {
      notificationURLInContent.close()
      const info = "PAGE: Edit email template\nEVENT: While validating whether the URL attribute is present in the email content"
      notificationURLInContent = notify.danger("URL missing in email content.Kindly add URL attribute.", info)
      return false
    }
    return true
  }

  const getEditorValues = () => {
    // flattening the nested object
    flatObject = flatenObject(parsedJson)

    //extracting keys from the flattened object
    let flatObjectKeys = Object.keys(flatObject)

    // flatObjectKeys = flatObjectKeys.sort((a, b) => b.localeCompare(a))

    // for (let i = 0; i < flatObjectKeys.length; i++) {
    //   let key = flatObjectKeys[i]
    //   let regex = new RegExp(`{{\\s*${key}\\s*}(?!})`, "g") // Match `{{key}` but not `{{key}}`
    //   emailTemplate.content = emailTemplate.content.replaceAll(regex, `{{${key}}}`)

    //   // Match `{{key` without a closing brace
    //   let incompleteRegex = /{{\\s*${key}(?!\\s*}})/g
    //   emailTemplate.content = emailTemplate.content.replaceAll(incompleteRegex, `{{${key}}}`) // Add closing braces
    // }

    emailTemplate.content = parseInvalidAttributes(flatObjectKeys, emailTemplate.content)

    // Handle unknown keys (those not in flatObject) by making sure they are properly closed
    let unknownKeyRegex = /{{\s*([^}]+?)\s*}(?!})/g
    emailTemplate.content = emailTemplate.content.replaceAll(unknownKeyRegex, `{{$1}}`)

    // for replacing empty content inside curly brackets
    emailTemplate.content = emailTemplate.content.replaceAll(/\{\{\s*\}\}/g, "")

    // checking the values inside the double curly braces from the email content  which we get from the text editor
    editorValues = Array.from(new Set(emailTemplate.content.match(/(?<=\{\{).*?(?=\}\})/g)))

    // filtering the irrelevant text editor values
    let irrelevantEditorValues = editorValues.filter((value) => !flatObjectKeys.includes(value))

    //assigning irrelevant values to the editorValues
    editorValues = [...irrelevantEditorValues]
  }

  /**
   *@description Function to replace Invalid email variables from the email content
   */
  const replaceInvalidVariables = () => {
    for (let i = 0; i < editorValues.length; i++) {
      if (editorObj[editorValues[i]]) emailTemplate.content = emailTemplate.content.replaceAll(`{{${editorValues[i]}}}`, `{{${editorObj[editorValues[i]]}}}`)
    }
  }

  /**
   * @description - function to check not to exceed max characters
   */
  const checkMaxCharacters = () => {
    if (emailTemplate.headerText.length > maxCharHeaderText) {
      maxNotification.close()
      timer = setTimeout(() => {
        emailTemplate.headerText = emailTemplate.headerText.slice(0, maxCharHeaderText)
      }, 10)
      maxNotification = notify.info(`Header Text should not be more than ${maxCharHeaderText} characters`)
    }
  }

  /**
   * @description Function to scrolling to top of the page
   */
  const scrollTotop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }

  /**
   * @description  function to check not to exceed max characters
   */
  const exceedsmaxCharacters = (value, characters, msg) => {
    if (emailTemplate[value].length >= characters) {
      maxNotification.close()

      //returning values only in range below max characters
      setTimeout(() => {
        emailTemplate[value] = emailTemplate[value].slice(0, characters)
      }, 100)

      maxNotification = notify.info(msg)
    }
  }

  /**
   * @description Function to validate the image url
   */
  const checkImage = () => {
    return new Promise((resolve, reject) => {
      let image = document.createElement("img")

      //if the image not properly loaded
      image.onerror = (error) => {
        reject(error)
      }

      //if the image properly loaded
      image.onload = () => {
        resolve(image)
      }
      image.src = headerURL
    })
  }

  /**
   * function to check for given pattern to template name
   * @param e - to capture key event
   */
  const checkSpecialCharsSubject = (e) => {
    try {
      const info = "PAGE: Edit Email template\nEVENT: Validating invalid characters for the email subject during onBlur/ onPaste/ onKeypress"

      // Destructure the type and key properties from the event object
      let { type, key } = e

      // Regular expression to match allowed characters
      let allowedCharsRegex = /^[A-Za-z0-9\s-()+&.]+$/

      // Check if it's a keypress event and the pressed key is not allowed
      if (type === "keypress" && !allowedCharsRegex.test(key)) {
        e.preventDefault()

        emailTemplate.subject += key

        invalidNotification.close()

        // Prevent the default keypress behavior if the pressed key is not allowed
        // Show a danger notification indicating the allowed characters
        invalidNotification = notify.danger("Only letters, numbers, and special characters -()+&. are allowed.", info)
        setTimeout(() => {
          emailTemplate.subject = emailTemplate.subject.slice(0, -1)
        }, 100)
      } else if (type === "paste") {
        let pastedText
        if (type === "blur") {
          pastedText = emailTemplate.name
        } else {
          // Get the pasted text from the clipboard
          let clipboardData = e.clipboardData || window.clipboardData
          pastedText = clipboardData.getData("text/plain")
        }

        setTimeout(() => {
          invalidNotification.close()
          // Check if the pasted text contains any invalid special characters
          if (!allowedCharsRegex.test(pastedText)) {
            // Remove any characters that are not allowed
            let sanitizedText = pastedText.replace(/[^A-Za-z0-9\s-()+&.]/g, "").trim()

            // Check if the sanitized text is the same as the original pasted text
            if (sanitizedText !== pastedText) {
              invalidNotification = notify.danger("Invalid special characters found. Only letters, numbers, and special characters -()+&. are allowed.", info)
            }

            // Set the input value to the sanitized text
            emailTemplate.subject = sanitizedText
          }
          exceedsmaxCharacters("subject", maxCharactersSubject, `Template subject should not be more than ${maxCharactersSubject} characters`)
        }, 500)
      }
    } catch (error) {
      // console.error(error)
    }
  }
  /**
   * function to check for given pattern to template name
   * @param e - to capture key event
   */
  const checkSpecialCharsName = (e) => {
    try {
      const info = "PAGE: Edit Email template\nEVENT: Validating invalid characters for the email template name during onBlur/ onPaste/ onKeypress"

      // Destructure the type and key properties from the event object
      let { type, key } = e

      // Regular expression to match allowed characters
      let allowedCharsRegex = /^[A-Za-z0-9\s-()+&.]+$/

      // Check if it's a keypress event and the pressed key is not allowed
      if (type === "keypress" && !allowedCharsRegex.test(key)) {
        e.preventDefault()

        emailTemplate.name += key

        invalidNotification.close()

        // Prevent the default keypress behavior if the pressed key is not allowed
        // Show a danger notification indicating the allowed characters
        invalidNotification = notify.danger("Only letters, numbers, and special characters -()+&. are allowed.", info)
        setTimeout(() => {
          emailTemplate.name = emailTemplate.name.slice(0, -1)
        }, 100)
      } else if (type === "paste" || type === "blur") {
        let pastedText
        if (type === "blur") {
          pastedText = emailTemplate.name
        } else {
          // Get the pasted text from the clipboard
          let clipboardData = e.clipboardData || window.clipboardData
          pastedText = clipboardData.getData("text/plain")
        }

        setTimeout(() => {
          invalidNotification.close()
          // Check if the pasted text contains any invalid special characters
          if (!allowedCharsRegex.test(pastedText)) {
            // Remove any characters that are not allowed
            let sanitizedText = pastedText.replace(/[^A-Za-z0-9\s-()+&.]/g, "").trim()

            // Check if the sanitized text is the same as the original pasted text
            if (sanitizedText !== pastedText) {
              invalidNotification = notify.danger("Invalid special characters found. Only letters, numbers, and special characters -()+&. are allowed.", info)
            }

            // Set the input value to the sanitized text
            emailTemplate.name = sanitizedText
          }
          exceedsmaxCharacters("name", maxCharacters, `Template name should not be more than ${maxCharacters} characters`)
        }, 500)
      }
    } catch (error) {
      // console.error(error)
    }
  }

  onDestroy(async () => {
    // if (compareObjects(oldEmailData, JSON.parse(JSON.stringify(emailTemplate))) === false) {
    //   showBackmodal = true
    //   return
    // }
  })

  afterUpdate(() => {
    // emailTemplate.headerURL = headerURL
  })

  const onChangingType = async () => {
    if (emailTemplate.headerType == "text" || emailTemplate.headerType == "empty") {
      // if (!headerURL.trim()) {
      //   // headerURL = "https://print2block.com/img/logo1.png"
      // } else {
      //   try {
      //     let image = await checkImage()
      //     if (!image.naturalHeight) {
      //       throw "Invalid URL Found. Kindly enter the different URL"
      //     }
      //   } catch (error) {
      //     console.error(error)
      //     headerURL = "https://print2block.com/img/logo1.png"
      //   }
      // }
    } else if (emailTemplate.headerType == "image" || emailTemplate.headerType == "empty") {
      if (!emailTemplate.headerText.trim()) emailTemplate.headerText = "Test User"
    }
  }

  const applyAndContinue = async (e) => {
    editorObj = e.detail
    showSuggestionModal = false
    replaceInvalidVariables()
    // if (isSave) {
    //   let checkURL = checkURLInContent()
    //   if (checkURL) {

    //     await saveAfterValidate()
    //   }
    //   isSave = false
    // } else {
    //   let checkURL = checkURLInContent()
    //   if (checkURL) {
    //     previewModal = true
    //     scrollTotop()
    //   }
    // }
    let checkURL = checkURLInContent()
    if (checkURL) {
      showCustomize = false
      previewModal = true
      scrollTotop()
    }
  }

  /**
   * Fetches the next set of document templates based on a specified count.
   *
   * @param {Event} e - Event object containing details about the trigger.
   */
  const fetchNextTemplates = async (e) => {
    try {
      // Set the loading state to indicate data fetching
      showLoadingForDropDown = true

      // Store the document name from the event detail
      docTempName = e.detail

      // Increment the page count to retrieve the next set of templates
      page++

      // Fetch the list of document templates for the updated page
      let documentList = await getDocumentsList(page)

      // Calculate the updated start and end counts for template display
      if (page === 1) {
        startCount = page + 10
        if (maxPage === page) endCount = count
        else endCount = 10
      } else {
        startCount = startCount + 10
        if (maxPage === page) endCount = count
        else endCount = startCount + 9
      }

      // Update the documentTemplates with the fetched document templates
      documentTemplates = documentList.templates
    } catch (error) {
      // console.error(error)
      // Display an error notification and redirect to the bulk publishing page
      const info = "PAGE: Edit Email template\nEVENT: While fetching the list of document template on 'Next' button click"
      notify.danger(error, info)
      push("/templates/email", info)
    } finally {
      // Set the loading state to indicate data fetching is complete
      showLoadingForDropDown = false
    }
  }

  /**
   * Fetches the previous set of document templates based on a specified count.
   *
   * @param {Event} e - Event object containing details about the trigger.
   */
  const fetchPreviousTemplates = async (e) => {
    try {
      // Set the loading state to indicate data fetching
      showLoadingForDropDown = true

      // Store the document name from the event detail
      docTempName = e.detail

      // Decrement the page count to retrieve the previous set of templates
      page--

      // Fetch the list of document templates for the updated page
      let documentList = await getDocumentsList(page)

      // Calculate the updated start and end counts for template display
      startCount = startCount - 10
      endCount = startCount + 9

      // Update the documentTemplates with the fetched document templates
      documentTemplates = documentList.templates
    } catch (error) {
      const info = "PAGE: Edit Email template\nEVENT: While fetching the list of document template on 'Previous' button click"
      notify.danger(error, info)
      push("/templates/email")
    } finally {
      // Set the loading state to indicate data fetching is complete
      showLoadingForDropDown = false
    }
  }

  /**
   * Fetches the initial set of document templates based on a specified count.
   *
   * @param {Event} e - Event object containing details about the trigger.
   */
  const fetchInitialList = async (e) => {
    try {
      // Set the loading state to indicate data fetching
      showLoadingForDropDown = true

      // Store the document name from the event detail
      docTempName = e.detail

      // Increment the page count to retrieve the next set of templates
      page = 1

      // Fetch the list of document templates for the updated page
      let documentList = await getDocumentsList(page)

      // Calculate the updated start and end counts for template display
      startCount = 1
      endCount = 10

      // Update the documentTemplates with the fetched document templates
      documentTemplates = documentList.templates
    } catch (error) {
      const info = "PAGE: Edit Email template\nEVENT: While fetching the list of document template on 'Move Forward' button click"
      notify.danger(error, info)
      push("/templates/email")
    } finally {
      // Set the loading state to indicate data fetching is complete
      showLoadingForDropDown = false
    }
  }

  /**
   * Fetches the final set of document templates based on a specified count.
   *
   * @param {Event} e - Event object containing details about the trigger.
   */
  const fetchFinalList = async (e) => {
    try {
      // Set the loading state to indicate data fetching
      showLoadingForDropDown = true

      // Store the document name from the event detail
      docTempName = e.detail

      // Increment the page count to retrieve the next set of templates
      page = maxPage

      // Fetch the list of document templates for the updated page
      let documentList = await getDocumentsList(page)

      // Calculate the updated start and end counts for template display
      startCount = (maxPage - 1) * 10 + 1
      endCount = count

      // Update the documentTemplates with the fetched document templates
      documentTemplates = documentList.templates
    } catch (error) {
      const info = "PAGE: Edit Email template\nEVENT: While fetching the list of document template on 'Move Last' button click"
      notify.danger(error, info)
      push("/templates/email")
    } finally {
      // Set the loading state to indicate data fetching is complete
      showLoadingForDropDown = false
    }
  }

  // This function is called when a document's content changes
  const onDocTempChange = async (e) => {
    try {
      // Update the emailTemplate object with the new document content
      emailTemplate.document = e.detail

      if (emailTemplate.document) {
        // If there is document content, fetch additional information about the document
        let documentData = await getDocumentTemplate()
        docTempName = documentData.name

        // Parse the metadata fetched from the API
        // Note: The metadata appears to be a stringified JSON, so we parse it twice to convert it into an object
        parsedJson = JSON.parse(JSON.parse(JSON.stringify(documentData.metadata)))

        // Initialize various properties in the parsed metadata
        parsedJson.url = ""
        parsedJson.expireOn = new Date(new Date().setDate(new Date().getDate() + 1)).toDateString().slice(4)
        parsedJson.date = new Date().toDateString().slice(4)
        parsedJson.title = ""
        parsedJson.documentID = "67d4e8f0b3c74621fa9e5b7c"

        // Flatten the parsed JSON object (this might be a custom function not defined in this code snippet)
        flatObject = flatenObject(parsedJson)
      } else {
        // If there is no document content, initialize parsedJson as an empty object
        parsedJson = {}
      }
    } catch (error) {
      const info = "PAGE: Edit Email template\nEVENT: While changing document template"
      notify.danger(error, info)
    }
  }

  /**
   * Function for changing the document Template Name
   * @param {CustomEvent} e dispatched value from the component
   */
  const changeDocumentName = async (e) => {
    // assigning the document template name shown in tha dropdown
    docTempName = e.detail
  }

  // $: checkImageFile(imageFile)

  const checkImageFile = async (e) => {
    try {
      notificationInvaliFile.close()

      const MAX_FILE_SIZE = 2 * 1024 * 1024
      if (e.target.files[0].size > MAX_FILE_SIZE) {
        throw "Maximum File size exceeded"
      }

      imageFile = e.target.files[0]
      let validFile = await validateFile(imageFile)
      emailTemplate.headerURL = await storeImage(validFile)
    } catch (error) {
      const info = "PAGE: Edit Email template\nEVENT: While uploading image for email header"
      notificationInvaliFile = notify.danger(error, info)
    } finally {
      e.dataTransfer ? (e.dataTransfer.value = null) : (e.target.value = null)
    }
  }

  const storeImage = (imageFile) => {
    return new Promise(async (resolve, reject) => {
      try {
        if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
        const { data } = await axios.post(
          `/api/swagger/v2/templates/files/${emailTemplate.id}/image`,
          { file: imageFile },
          {
            headers: {
              "x-access-token": $ApplicationState.token,
              "Content-Type": "multipart/form-data",
            },
          }
        )
        //error checking while api call
        if (data.error && !data.success) {
          throw data.errorCode
        }

        resolve(data.uri)
      } catch (error) {
        reject(error)
      }
    })
  }
</script>

<svelte:head>
  <title>Edit Email Template</title>
</svelte:head>

{#if showBackmodal}
  <BackModal
    on:cancel={() => {
      showBackmodal = false
    }}
    on:dontSave={() => {
      notificationName.close()
      notificationSubject.close()
      notificationContent.close()
      notificationDocument.close()
      notificationURL.close()
      notificationText.close()
      notificationURLInContent.close()
      invalidNotification.close()
      notificationInvalidURL.close()
      showBackmodal = false
      push("/templates/email")
    }}
    templateType="Email"
    on:click={async () => {
      showBackmodal = false
      await saveTemplate()
    }}
  />
{/if}

{#if showDeleteModal}
  <DeleteConfirmation
    on:click={() => {
      showDeleteModal = false
    }}
    template={emailTemplate}
    DocumentType="Email"
    on:delete={async () => {
      await deleteTemplate()
      showBackmodal = false
    }}
  />
{/if}

{#if showSuggestionModal}
  <SuggestionModal
    {parsedJson}
    {editorValues}
    on:closeModal={() => {
      showSuggestionModal = false
      if (isSave) {
        isSave = false
      }
    }}
    on:applyAndContinue={(e) => {
      applyAndContinue(e)
    }}
  />
{/if}

<div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] pb-24 dark:bg-bodyblack">
  <Navbar />
  {#if previewModal}
    <div class="relative z-50" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div class="fixed inset-0 z-50 overflow-y-auto bg-[#000000cc] backdrop-blur-md">
        <div class="flex items-end justify-center overflow-hidden p-6 text-center sm:items-center">
          <Preview
            on:closePreview={async () => {
              previewModal = false
              if (isSave) {
                await saveAfterValidate()
                isSave = false
              }
              // closePreview()
            }}
            {emailTemplate}
            {flatObject}
          />
        </div>
      </div>
    </div>
  {/if}

  {#if showLoading}
    <Loader>
      <span class="flex">
        {@html loadingText}
      </span>
    </Loader>
  {/if}

  <div class="px-6 pb-12 pt-6">
    <div class="mx-auto w-full max-w-[920px]">
      <div class="mx-auto w-full">
        <button
          type="button"
          on:click={async () => {
            // let validateContent = await validateEmailDetails()

            // if (validateContent) {

            notificationName.close()
            notificationSubject.close()
            notificationContent.close()
            notificationDocument.close()
            notificationURL.close()
            notificationText.close()
            notificationURLInContent.close()
            invalidNotification.close()
            notificationInvalidURL.close()

            if (compareObjects(oldEmailData, JSON.parse(JSON.stringify(emailTemplate))) === false) {
              showBackmodal = true
              return
            }

            push("/templates/email")
            // }
          }}
          style="text-decoration: none;"
          class="mb-1 hidden w-16 cursor-pointer select-none text-base font-medium text-gray-200 hover:text-blue-600 focus-visible:text-blue-600 focus-visible:outline-none active:text-blue-500 sm:mb-0 md:block"
        >
          <span>
            <i class="fa-solid fa-reply" />
            <span>&nbsp;Back&nbsp;</span>
          </span>
        </button>

        <div class="flex flex-col items-center justify-between gap-0 mobile:gap-3 md:flex-row">
          <!-- <div class="select-none text-xl font-bold text-black lg:text-2xl xl:text-2xl">Edit Email Template</div> -->
          <div class="mx-auto mt-3 flex flex-col items-center justify-center mobile:mt-0 md:ml-0 md:items-start lg:mx-0">
            <div class="select-none text-xl font-bold text-black dark:text-white lg:text-2xl xl:text-2xl">Edit Email Template</div>
          </div>
          <div class="mt-3 flex items-center justify-center gap-3 md:mt-0">
            <div data-tooltip="Back to List" tooltip-position="top" class="block md:hidden">
              <button
                type="button"
                on:click={async () => {
                  let validateContent = await validateEmailDetails()

                  if (validateContent) {
                    if (compareObjects(oldEmailData, JSON.parse(JSON.stringify(emailTemplate))) === false) {
                      showBackmodal = true
                      return
                    }
                    push("/templates/email")
                  }
                }}
                class="flex h-9 min-w-[36px] cursor-pointer items-center justify-center rounded-md border border-[#a0a1a580] bg-white px-2 text-sm font-medium text-gray-900 no-underline hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 dark:bg-lightgray dark:text-white dark:hover:bg-blue-600"
              >
                <i class="fa-solid fa-reply" />
              </button>
            </div>
            <button
              on:click={() => {
                showDeleteModal = true
              }}
              class:pointer-events-none={showLoading}
              data-tooltip="Delete Template"
              tooltip-position="top"
              class="flex h-9 w-9 items-center justify-center rounded-md border border-[#a0a1a580] bg-white text-sm font-medium text-gray-900 hover:bg-red-600 hover:text-white focus:outline-none active:bg-red-500 dark:bg-lightgray dark:text-white dark:hover:bg-red-500"
            >
              <i class="fa-solid fa-trash-can" />
            </button>

            <button disabled={disableBtn} on:click={previewTemplate} class:pointer-events-none={showLoading} data-tooltip="Preview Template" tooltip-position="top" class="flex h-9 w-9 items-center justify-center rounded-md border border-[#a0a1a580] bg-white px-2 text-sm font-medium text-gray-900 hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 dark:bg-lightgray dark:text-white dark:hover:bg-blue-500">
              <i class="fa-solid fa-eye" />
            </button>

            <!-- <button
              disabled={disableBtn}
              on:click={async () => {
                await saveTemplate()
                showBackmodal = false
              }}
              class:pointer-events-none={showLoading}
              data-tooltip="Save Template"
              tooltip-position="top"
              class="flex h-9 w-9 items-center justify-center rounded-md border border-[#a0a1a580] bg-white px-2 text-sm font-medium text-gray-900 hover:bg-green-600 hover:text-white focus:outline-none active:bg-green-500 disabled:cursor-not-allowed disabled:bg-[#f7f7f7] disabled:text-gray-900/50 dark:bg-lightgray dark:text-white dark:hover:bg-green-500"
            >
              <i class="fa-solid fa-floppy-disk" />
            </button> -->
            <button disabled={disableBtn} on:click={saveTemplate} type="button" class="flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-green-500 px-3 py-1.5 text-sm font-medium text-white hover:bg-green-600 hover:text-white focus:outline-none disabled:cursor-not-allowed disabled:bg-[#f7f7f7]/50 disabled:text-gray-900/50 dark:bg-green-500 dark:text-white dark:hover:bg-green-600 sm:w-auto">
              <span>
                <i class="fa-solid fa-floppy-disk" />
              </span>
              <span class="select-none">&nbsp;Save&nbsp;Template</span>
            </button>
          </div>
        </div>
      </div>

      <div class="mt-3 flex pb-12">
        <div class="relative mx-auto h-full w-full rounded-md bg-white p-6 dark:bg-darkgray">
          <div class="relative w-full rounded-md bg-white dark:bg-darkgray">
            <div class="space-y-3">
              <div class="sm:grid sm:grid-cols-3 sm:items-start md:items-center">
                <div class="mb-1 block select-none text-base font-medium text-gray-200 sm:mb-0">Name</div>
                <div class="sm:col-span-2 sm:mt-0">
                  <input
                    required
                    on:keypress={() => {
                      exceedsmaxCharacters("name", maxCharacters, `Template name should not be more than ${maxCharacters} characters`)
                    }}
                    on:keypress={(e) => {
                      clearTimeout(timer)
                      timer = setTimeout(checkSpecialCharsName(e), 50)
                    }}
                    on:blur={checkSpecialCharsName}
                    on:paste={checkSpecialCharsName}
                    on:paste={() => {
                      exceedsmaxCharacters("name", maxCharacters, `Template name should not be more than ${maxCharacters} characters`)
                    }}
                    bind:value={emailTemplate.name}
                    type="text"
                    class="block w-full appearance-none rounded-md border border-[#a0a1a580] bg-transparent px-3 py-2 pl-5 text-sm text-gray-800 placeholder-gray-200 outline-none invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:text-white"
                    placeholder="Email Template name"
                  />
                </div>
              </div>
              <div class="sm:grid sm:grid-cols-3 sm:items-start md:items-center">
                <div class="mb-1 block select-none text-base font-medium text-gray-200 sm:mb-0">Document Template</div>
                <div class="w-full sm:col-span-2 sm:mt-0">
                  <!-- svelte-ignore empty-block -->
                  {#if loadDropdown}
                    <div class="flex h-[38px] w-full items-center rounded-md border border-[#a0a1a580] pl-5 text-sm text-white">
                      Loading&nbsp;&nbsp;
                      <span>
                        <Loading />
                      </span>
                    </div>
                  {:else}
                    <DocumentDropdown on:moveLast={fetchFinalList} on:moveFirst={fetchInitialList} bind:showLoading={showLoadingForDropDown} selectedName={docTempName} on:itemSelect={onDocTempChange} on:selectedName={changeDocumentName} on:fetchNext={fetchNextTemplates} on:fetchPrevious={fetchPreviousTemplates} {startCount} {endCount} {maxPage} {page} {count} selected={emailTemplate.document || "None"} dropdownItems={documentTemplates} />
                  {/if}
                </div>
              </div>
              <div class="sm:grid sm:grid-cols-3 sm:items-start md:items-center">
                <div class="mb-1 block select-none text-base font-medium text-gray-200 sm:mb-0">Subject</div>
                <div class="sm:col-span-2 sm:mt-0">
                  <input
                    required
                    bind:value={emailTemplate.subject}
                    on:blur={checkSpecialCharsSubject}
                    on:keypress={() => {
                      exceedsmaxCharacters("subject", maxCharactersSubject, `Template subject should not be more than ${maxCharactersSubject} characters`)
                    }}
                    on:keypress={(e) => {
                      clearTimeout(timer)
                      timer = setTimeout(checkSpecialCharsSubject(e), 50)
                    }}
                    on:paste={checkSpecialCharsSubject}
                    on:paste={() => {
                      exceedsmaxCharacters("subject", maxCharactersSubject, `Template subject should not be more than ${maxCharactersSubject} characters`)
                    }}
                    type="text"
                    class="block w-full appearance-none rounded-md border border-[#a0a1a580] bg-transparent px-3 py-2 pl-5 text-sm text-gray-800 placeholder-gray-200 outline-none invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:text-white"
                    placeholder="Subject of the mail"
                  />
                </div>
              </div>

              <!-- svelte-ignore a11y-click-events-have-key-events -->
              <!-- <div
              class="cursor-pointer sm:grid sm:grid-cols-3 sm:items-start md:items-center"
            
            > -->
              <!-- <div class=" mb-1 flex select-none items-center text-base font-bold text-gray-900 dark:text-slate-200 sm:mb-0">
                <div class="px-3 py-2 text-sm text-gray-900 dark:text-slate-200">
                  <i class="fa-solid fa-screwdriver-wrench" />
                </div>
                <span>Customise&nbsp;&nbsp;</span>
                <div class="px-3 py-2 text-sm text-gray-900 dark:text-slate-200">
                  <i class="fa-solid {showCustomize ? 'fa-chevron-up' : 'fa-chevron-down'}" />
                </div>
              </div> -->
              <button
                on:click={() => {
                  showCustomize = !showCustomize
                }}
                class="flex items-center justify-center rounded-full border-0 bg-blue-500 px-6 py-1 text-lg text-white hover:bg-blue-600 focus:outline-none"
              >
                <div class=" text-sm text-slate-200">
                  <i class="fa-solid fa-screwdriver-wrench" />
                </div>
                &nbsp;&nbsp; Customize
              </button>
              <!-- </div> -->

              {#if showCustomize}
                <div class="flex w-full flex-col gap-3 lg:flex-row lg:gap-0">
                  <div class="mb-1 block w-full select-none text-base font-medium text-gray-500 sm:mb-0 lg:w-2/5">
                    <div class="h-[380px] w-full overflow-hidden mobile:h-[480px] lg:rounded-md">
                      <div class="pointer-events-none flex h-full w-full select-none items-center justify-center overflow-hidden bg-gray-900">
                        <div class="relative h-full w-full">
                          <div class="blur-area absolute inset-0 z-10" />
                          <Preview card={true} {emailTemplate} {flatObject} translateposition="editPreview" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class=" w-full pl-0 sm:mt-0 lg:pl-6">
                    <div class="mb-3 w-full border-b-2 border-[#a0a1a580]">
                      <div class="-mb-px flex select-none justify-around">
                        <button
                          on:click={() => {
                            activeTab = "cardHeader"
                          }}
                          type="button"
                          class="flex items-center whitespace-nowrap border-b-2 {activeTab == 'cardHeader' ? 'border-blue-500' : 'border-transparent'} py-2 text-base font-bold text-black dark:text-white"
                        >
                          <span class="hidden md:block">Card &nbsp;</span>
                          Header
                        </button>
                        <button
                          on:click={() => {
                            activeTab = "cardBody"
                          }}
                          type="button"
                          class="flex items-center whitespace-nowrap border-b-2 {activeTab == 'cardBody' ? 'border-blue-500' : 'border-transparent'} py-2 text-base font-bold text-black dark:text-white"
                        >
                          Card&nbsp;
                          <span class="hidden md:block">Body</span>
                        </button>
                        <button
                          on:click={() => {
                            activeTab = "bgColor"
                          }}
                          type="button"
                          class="flex items-center whitespace-nowrap border-b-2 {activeTab == 'bgColor' ? 'border-blue-500' : 'border-transparent'} border-blue-500 py-2 text-base font-bold text-black dark:text-white"
                        >
                          Background Color
                        </button>
                      </div>
                    </div>

                    {#if activeTab == "cardBody"}
                      <div class="mb-3 sm:w-full sm:items-start md:items-center">
                        <div class="block select-none text-base font-medium text-gray-500 dark:text-gray-200">Card Background</div>
                        <div class="mt-1 w-full">
                          <div class="w-full">
                            <Palette bind:headerBackground={emailTemplate.cardBackground} colorCount={18} bind:customColors={body_bg_custom} />
                          </div>
                        </div>
                      </div>
                      <div class="mb-3 sm:w-full sm:items-start md:items-center">
                        <div class=" block select-none text-base font-medium text-gray-500 dark:text-gray-200">Card Width</div>
                        <div class="mt-1 w-full">
                          <div class="relative flex h-9 w-full items-center">
                            <input
                              class="h-1 w-10/12 cursor-pointer rounded-md"
                              type="range"
                              on:change={(e) => {
                                if (e.target.value) emailTemplate.cardWidth = Math.abs(e.target.value)
                              }}
                              on:wheel|preventDefault|stopPropagation={(e) => {
                                if (e.deltaY < 0) {
                                  emailTemplate.cardWidth = Math.min(800, emailTemplate.cardWidth + 10)
                                } else {
                                  emailTemplate.cardWidth = Math.max(550, emailTemplate.cardWidth - 10)
                                }
                              }}
                              min="550"
                              max="800"
                              bind:value={emailTemplate.cardWidth}
                            />
                            <div class="flex w-2/12 items-center">
                              <input readonly class="pointer-events-none w-full text-right dark:bg-transparent dark:text-slate-200" type="text" value={emailTemplate.cardWidth} />
                              <span class="text-sm text-gray-800 dark:text-slate-200">&nbsp;px</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="mb-3 sm:w-full sm:items-start md:items-center">
                        <div class=" block select-none text-base font-medium text-gray-500 dark:text-gray-200">Rounded Edges</div>
                        <div class="mt-1 w-full">
                          <div class="relative flex h-9 w-full items-center">
                            <input
                              class="h-1 w-10/12 cursor-pointer rounded-md"
                              type="range"
                              on:change={(e) => {
                                if (e.target.value) emailTemplate.cardRadius = Math.abs(e.target.value)
                              }}
                              on:wheel|preventDefault|stopPropagation={(e) => {
                                if (e.deltaY < 0) {
                                  emailTemplate.cardRadius = Math.min(60, emailTemplate.cardRadius + 5)
                                } else {
                                  emailTemplate.cardRadius = Math.max(0, emailTemplate.cardRadius - 5)
                                }
                              }}
                              min="0"
                              max="60"
                              bind:value={emailTemplate.cardRadius}
                            />
                            <div class="flex w-2/12 items-center">
                              <input readonly class="pointer-events-none w-full text-right dark:bg-transparent dark:text-slate-200" type="text" value={emailTemplate.cardRadius} />
                              <span class="text-sm text-gray-800 dark:text-slate-200">&nbsp;px</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="mb-3 sm:w-full sm:items-start md:items-center">
                        <div class="block select-none text-base font-medium text-gray-500 dark:text-gray-200">Card Padding</div>
                        <div class="mt-1 w-full">
                          <div class="relative flex h-9 w-full items-center">
                            <input
                              class="h-1 w-10/12 cursor-pointer rounded-md"
                              type="range"
                              on:change={(e) => {
                                if (e.target.value) emailTemplate.cardPadding = Math.abs(e.target.value)
                              }}
                              on:wheel|preventDefault|stopPropagation={(e) => {
                                if (e.deltaY < 0) {
                                  emailTemplate.cardPadding = Math.min(100, emailTemplate.cardPadding + 5)
                                } else {
                                  emailTemplate.cardPadding = Math.max(10, emailTemplate.cardPadding - 5)
                                }
                              }}
                              min="10"
                              max="100"
                              bind:value={emailTemplate.cardPadding}
                            />
                            <div class="flex w-2/12 items-center">
                              <input readonly class="pointer-events-none w-full text-right dark:bg-transparent dark:text-slate-200" type="text" value={emailTemplate.cardPadding} />
                              <span class="text-sm text-gray-800 dark:text-slate-200">&nbsp;px</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    {:else if activeTab == "bgColor"}
                      <div class="sm:w-full sm:items-start md:items-center">
                        <div class="block select-none text-base font-medium text-gray-500 dark:text-gray-200">Email Background</div>
                        <div class="mt-1 w-full">
                          <div class="w-full">
                            <Palette bind:headerBackground={emailTemplate.background} colorCount={18} bind:customColors={email_bg_custom} />
                          </div>
                        </div>
                      </div>
                    {:else}
                      <div class="mb-3 sm:w-full sm:items-start md:items-center">
                        <div class="block select-none text-base font-medium text-gray-500 dark:text-gray-200">Show Header</div>
                        <div class="mt-1 w-full">
                          <HeaderDropdown on:changeType={onChangingType} bind:dispatchValue={emailTemplate.headerType} />
                        </div>
                      </div>

                      {#if emailTemplate.headerType != "empty"}
                        {#if emailTemplate.headerType == "text"}
                          <div class="mb-3 sm:w-full sm:items-start md:items-center">
                            <div class="block select-none text-base font-medium text-gray-500 dark:text-gray-200">Title Text</div>
                            <div class="mt-1 w-full">
                              <input
                                required
                                on:input={() => {
                                  notificationText.close()
                                }}
                                on:keypress={checkMaxCharacters}
                                bind:value={emailTemplate.headerText}
                                type="text"
                                class="block w-full appearance-none rounded-md border border-[#a0a1a580] bg-transparent px-3 py-2 pl-5 text-sm text-gray-800 placeholder-gray-200 outline-none invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:text-slate-200"
                                placeholder="Enter Title Text"
                              />
                            </div>
                          </div>
                          <div class="mb-3 sm:w-full sm:items-start md:items-center">
                            <div class="flex w-full gap-3">
                              <div class="w-4/6 md:w-4/6">
                                <div class="mb-1 block select-none text-base font-medium text-gray-500 dark:text-gray-200">Font Family</div>
                                <Dropdown bind:activeItem={emailTemplate.headerFont} />
                              </div>
                              <div class="w-2/6 md:w-2/6">
                                <div class="mb-1 hidden select-none text-base font-medium text-gray-500 dark:text-gray-200 sm:block">Font Size</div>
                                <div class="mb-1 block select-none text-base font-medium text-gray-500 dark:text-gray-200 sm:hidden">Size</div>
                                <FontSizeDropdown bind:activeItem={emailTemplate.headerFontSize} />
                              </div>
                            </div>
                          </div>
                          <div class="mt-1 flex w-full gap-3">
                            <div class="mb-3 w-1/2 items-center">
                              <div class=" block select-none text-base font-medium text-gray-500 dark:text-gray-200">Text Color</div>
                              <div class="mt-1 w-full">
                                <div class="w-full">
                                  <Palette bind:headerBackground={emailTemplate.headerTextColor} colorCount={18} disableGradient={true} position="top" bind:customColors={header_txt_custom} />
                                </div>
                              </div>
                            </div>

                            <div class="mb-3 w-1/2 sm:items-start md:items-center">
                              <div class="block select-none text-base font-medium text-gray-500 dark:text-gray-200 md:hidden">Bg Color</div>
                              <div class="hidden select-none text-base font-medium text-gray-500 dark:text-gray-200 md:block">Background Color</div>
                              <div class="mt-1 w-full">
                                <div class="w-full">
                                  <Palette bind:headerBackground={emailTemplate.headerBackground} position="top" colorCount={18} bind:customColors={header_bg_custom} />
                                </div>
                              </div>
                            </div>
                          </div>
                        {:else}
                          <div class="block select-none text-base font-medium text-gray-500 dark:text-gray-200">Header Image</div>
                          <div class="mb-3 mt-1 sm:w-full sm:items-start md:items-center">
                            {#if !emailTemplate.headerURL}
                              <div class="relative flex cursor-pointer flex-col items-center justify-center gap-3 rounded-md border border-stone-700 bg-transparent p-6">
                                <input on:input={checkImageFile} type="file" name="headerImage" class="absolute inset-0 cursor-pointer opacity-0" accept="image/*" />
                                <span class="text-xl text-gray-g00">
                                  <i class="fa-solid fa-image" />
                                </span>
                                <div class="flex flex-col items-center justify-center">
                                  <p class="text-center text-sm text-gray-800 dark:text-white">Select a file by dragging and dropping it, or Click here to upload</p>
                                  <span class="select-none pt-2 text-center text-xs font-normal text-gray-g00">Maximum Size 2MB</span>
                                  <span class="pt-2 text-center text-xs text-gray-g00">Choose jpeg, jpg, png files</span>
                                </div>
                              </div>
                            {:else}
                              <div class="flex w-full items-center gap-3 rounded-md border border-stone-700">
                                <div class="group relative flex w-full justify-center p-3">
                                  <img src={emailTemplate.headerURL} alt="headerImage" class="aspect-auto w-1/3 rounded-md" />
                                  <div type="button" class="absolute inset-0 hidden items-center justify-center bg-[#000000cc] text-2xl group-hover:flex group-hover:text-red-500">
                                    <div class="relative">
                                      <button class="h-full w-full rounded-md border border-white bg-transparent bg-white px-3 py-1 text-base font-normal text-white group-hover:font-bold group-hover:text-blue-500">Change File</button>
                                      <input type="file" on:input={checkImageFile} class="absolute inset-0 z-10 cursor-pointer opacity-0" accept="image/*" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            {/if}
                            <!-- <input
                            required
                            on:blur={async () => {
                              if (headerURL.trim()) {
                                try {
                                  let image = await checkImage()
                                  if (!image.naturalHeight) {
                                    throw "Invalid URL Found. Kindly enter the different URL"
                                  }
                                } catch (error) {
                                  notificationInvalidURL.close()
                                  console.error(error)
                                  notificationInvalidURL = notify.danger("Invalid URL Found. Kindly enter the different URL")
                                }
                              }
                            }}
                            on:input={() => {
                              notificationURL.close()
                            }}
                            bind:value={headerURL}
                            type="text"
                            class="block w-full appearance-none rounded-md border border-[#a0a1a580] bg-transparent px-3 py-2 pl-5 text-sm text-gray-800 placeholder-gray-200 outline-none invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:text-slate-200"
                            placeholder="Enter Image URL"
                          /> -->
                          </div>
                          <div class="mb-3 sm:w-full sm:items-start md:items-center">
                            <div class="block select-none text-base font-medium text-gray-500 dark:text-gray-200">Background Color</div>
                            <div class="mt-1 w-full">
                              <div class="w-full {!emailTemplate.headerURL ? 'pointer-events-none cursor-not-allowed' : ''}">
                                <Palette bind:headerBackground={emailTemplate.headerBackground} position="top" colorCount={18} bind:customColors={header_bg_custom} />
                              </div>
                            </div>
                          </div>
                        {/if}
                      {/if}
                    {/if}
                  </div>
                </div>
              {/if}

              <div class="!mt-4 mobile:!mt-8 md:h-[60%] xl:h-[45%]" class:pointer-events-none={previewModal || showSuggestionModal || showDeleteModal}>
                <TextEditor {qrSource} bind:content={emailTemplate.content} {parsedJson} color={emailTemplate.cardBackground} />
              </div>

              <div class="flex justify-end gap-3">
                <button disabled={disableBtn} on:click={previewTemplate} type="button" class="flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-[#f7f7f7] px-3 py-1.5 text-sm font-medium text-gray-900 hover:bg-blue-500 hover:text-white focus:outline-none disabled:cursor-not-allowed disabled:bg-[#f7f7f7]/50 disabled:text-gray-900/50 dark:bg-lightgray dark:text-white dark:hover:bg-blue-500 sm:w-auto">
                  <span>
                    <i class="fa-solid fa-eye" />
                  </span>
                  <span class="select-none">&nbsp;Preview&nbsp;Template</span>
                </button>
                <button disabled={disableBtn} on:click={saveTemplate} type="button" class="flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-green-500 px-3 py-1.5 text-sm font-medium text-white hover:bg-green-600 hover:text-white focus:outline-none disabled:cursor-not-allowed disabled:bg-[#f7f7f7]/50 disabled:text-gray-900/50 dark:bg-green-500 dark:text-white dark:hover:bg-green-600 sm:w-auto">
                  <span>
                    <i class="fa-solid fa-floppy-disk" />
                  </span>
                  <span class="select-none">&nbsp;Save&nbsp;Template</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Footer />
</div>

<style global>
  a {
    text-decoration: auto;
  }
</style>
